import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-address-kind-list',
	templateUrl: './address-kind-list.component.html',
	styleUrls: ['./address-kind-list.component.css'],
})
export class AddressKindListComponent extends ListComponent {
	protected apiUrl = 'address_kind';
	protected apiType = 'bag';
	codebook;
	title: string;
	tableRows = [{ id: 'kind', name: 'Rodzaj' }];

	filters = {
		limit: 9999,
	};

	protected loadBefore(): void {
		this.bag.get('/codebook/12/', (result, error) => {
			this.codebook = result;

			this.title = `Słowniki -> ${this.codebook.name}`;
			this.loadData();
		});
	}
}
